import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import GridList, {processPagingParams} from '../fw/GridList.react';
import {defaultPageSize} from '../fw/PagingGrid.react';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import {FullScreenPanel} from './EmbededPanel.react';
import {maxTextLength} from '../fw/Tool';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import EventTracker from '../app/EventTracker';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

interface MenuProps {
    relay: object;
    user: User;
}

class Menu extends React.Component<MenuProps> {

    static propTypes = {
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);
    }

    getUrl = (item) => {
        return urlMapping.getUrl('panel', 'menu-channel', item);
    };

    render() {
        const {channels} = this.props.user.organisation;
        const list = channels;
        let type = types['channels'];

        return (
            <FullScreenPanel hideMenu showBackToPanel typeForTest="menu">
                <div className="bordered-content">
                    <h2 className="title-underline">{maxTextLength(this.props.user.organisation.name)}</h2>
                    {this.props.user.organisation.description ? <p className="grey">{maxTextLength(this.props.user.organisation.description, 500)}</p> : null}

                    <GridList
                        edges={list}
                        getUrl={this.getUrl}
                        iconProperty="channelDef.icon"
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        titleProperty="name"
                        titleProperty2="channelDef.name"
                        urlMapping={urlMapping}
                    />
                </div>
            </FullScreenPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(Menu, (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        first: defaultPageSize,
        after: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    realId,
                    ${EventTracker.getFragment()},
                    organisation(id: $organisationId) {
                        id,
                        realId,
                        name,
                        description,
                        channels(first: $first, after: $after) {
                            edges {
                                node {
                                    name,
                                    type,
                                    channelDef {
                                        id,
                                        icon,
                                        name,
                                    },
                                    id,
                                    organisation_id,
                                }
                            },
                            pageInfo {
                                hasNextPage,
                                hasPreviousPage,
                                startCursor,
                                endCursor
                            }
                        }
                    }
                }`;
        }
    },


});
